export default __webpack_public_path__ + "static/media/share-icon.45d07365.svg";